import React from 'react';
import { OrganizationTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { RouteProp } from '@react-navigation/native';
import useOrganizationInvitationDefinitions from '../../../../../hooks/api/useOrganizationInvitationDefinitions';
import EditInvitationDefinitionForm from './EditInvitationDefinitionForm';

export type EditInvitationDefinitionScreenOwnProps = {};

export type EditInvitationDefinitionScreenProps = EditInvitationDefinitionScreenOwnProps & {
    route: RouteProp<OrganizationTabParamList, 'edit-invitation-template'>;
};

const EditInvitationDefinitionScreen: React.FC<EditInvitationDefinitionScreenProps> = (props) => {
    const goBack = useGoBack();
    const {
        isLoadingInvitationDefinition,
        invitationDefinition,
        isUpdatingInvitationDefinition,
        updateInvitationDefinition,
    } = useOrganizationInvitationDefinitions({
        onUpdateInvitationDefinitionSuccess: goBack,
        invitationDefinitionId: props.route.params.invitationTemplateId,
    });
    return (
        <AnimateLoadedContent
            isLoading={isLoadingInvitationDefinition || !invitationDefinition || isUpdatingInvitationDefinition}
        >
            {() => (
                <EditInvitationDefinitionForm
                    invitationDefinition={invitationDefinition!}
                    onUpdate={(invitationDefinition) =>
                        updateInvitationDefinition({
                            invitationDefinition,
                            invitationDefinitionId: props.route.params.invitationTemplateId,
                        })
                    }
                    onCancel={goBack}
                />
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(EditInvitationDefinitionScreen);
